// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { VehiclePlansAreaId } from './VehiclePlansAreaId'
import { VehiclePlansAreaNavigation } from './VehiclePlansAreaNavigation'
import { VehiclePlansAreaRoutes } from './VehiclePlansAreaRoutes'

const LazyVehiclePlansComponent = lazy(() => import('./VehiclePlansArea'))

const VehiclePlansComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyVehiclePlansComponent />
  </SuspenseLoadingWrapper>
)

export const VehiclePlansArea = {
  id: VehiclePlansAreaId,
  requiredRight: BoumRight.VEHICLE_PLAN_R,
  NavigationComponent: VehiclePlansAreaNavigation,
  route: {
    path: VehiclePlansAreaRoutes.route,
    component: VehiclePlansComponent,
  },
}
